(() => {
  if (window.rhLensMenuBound) return;
  window.rhLensMenuBound = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.rh-lens-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rh-lens-menu[open]').forEach((menu) => {
      const hadFocus = menu.contains(document.activeElement);
      menu.open = false;
      if (hadFocus) menu.querySelector('summary').focus();
    });
  });
})();
